import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#000",
    d: "m13.436 1.557-9.37 9.368a2.297 2.297 0 0 0 1.607 3.956 2.3 2.3 0 0 0 1.635-.712l5.53-5.538v18.418a2.294 2.294 0 0 0 4.587 0V8.682l5.495 5.487a2.294 2.294 0 0 0 3.241-3.244l-9.368-9.368a2.28 2.28 0 0 0-1.679-.672h-.057c-.607 0-1.191.241-1.622.672"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M.885 29.342V.885h28.457v28.457z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }